import { render, staticRenderFns } from "./ProductorCourses.vue?vue&type=template&id=5a776daa"
import script from "./ProductorCourses.vue?vue&type=script&lang=js"
export * from "./ProductorCourses.vue?vue&type=script&lang=js"
import style0 from "./ProductorCourses.vue?vue&type=style&index=0&id=5a776daa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports